import { render, staticRenderFns } from "./EffectPreview.vue?vue&type=template&id=52fdc582&scoped=true"
import script from "./EffectPreview.vue?vue&type=script&lang=js"
export * from "./EffectPreview.vue?vue&type=script&lang=js"
import style0 from "./EffectPreview.vue?vue&type=style&index=0&id=52fdc582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fdc582",
  null
  
)

export default component.exports